export interface LoggedUser {
    usuario: string,
    token: string,
    expiration: string,
}

export function GetVoidLoggedUser(): LoggedUser {
    return {
        usuario: '',
        token: '',
        expiration: '',
    }
}
export function SetLoggedUser(data: any): LoggedUser {
    return {
        usuario: data.usuario ?? '',
        token: data.token ?? '',
        expiration: data.expiration ?? '',
    }
}

export const mapTokenData = (tokenData: any, tokenP: string): { usuario: string,  token: string, expiration: string } => {
    return {
        usuario: tokenData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/eamiladdress"] || '',
       
        token: tokenP, // Si tienes el token, puedes incluirlo aqu�
        expiration: tokenData["exp"] || '', // Convertir el timestamp de exp a una fecha legible
    };
};